import {
  CREATE_PRODUCT,
  CREATE_PRODUCT_SUCCESS,
  CREATE_PRODUCT_FAILURE,
  GET_PRODUCT_LIST,
  GET_PRODUCT_LIST_SUCCESS,
  GET_PRODUCT_LIST_FAILURE,
  UPDATE_PRODUCT,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAILURE,
  VIEW_PRODUCT,
  VIEW_PRODUCT_SUCCESS,
  VIEW_PRODUCT_FAILURE,
  UPDATE_STATUS_PRODUCT,
  UPDATE_STATUS_PRODUCT_SUCCESS,
  UPDATE_STATUS_PRODUCT_FAILURE,
  RENEWABLE_LESSON_ADD_TYPE,
  RENEWABLE_LESSON_ADD_TYPE_SUCCESS,
  RENEWABLE_LESSON_ADD_TYPE_FAILURE,
  RENEWABLE_LESSON_ADD_SUB_TYPE,
  RENEWABLE_LESSON_ADD_SUB_TYPE_SUCCESS,
  RENEWABLE_LESSON_ADD_SUB_TYPE_FAILURE,
  RENEWABLE_LESSON_SUBMIT,
  RENEWABLE_LESSON_SUBMIT_SUCCESS,
  RENEWABLE_LESSON_SUBMIT_FAILURE,
  GET_VIEW_LESSON,
  GET_VIEW_LESSON_SUCCESS,
  GET_VIEW_LESSON_FAILURE,
  EDIT_LESSON,
  EDIT_LESSON_SUCCESS,
  EDIT_LESSON_FAILURE,
  GET_VIEW_SUB_LESSON,
  GET_VIEW_SUB_LESSON_SUCCESS,
  GET_VIEW_SUB_LESSON_FAILURE,
  EDIT_SUB_LESSON,
  EDIT_SUB_LESSON_SUCCESS,
  EDIT_SUB_LESSON_FAILURE,
  UPDATE_LESSION_STATUS,
  UPDATE_LESSION_STATUS_SUCCESS,
  UPDATE_LESSION_STATUS_FAILURE,
  UPDATE_SUB_LESSION_STATUS,
  UPDATE_SUB_LESSION_STATUS_SUCCESS,
  UPDATE_SUB_LESSION_STATUS_FAILURE,
  GET_CURRICULUM_HEADING,
  GET_CURRICULUM_HEADING_SUCCESS,
  GET_CURRICULUM_HEADING_FAILURE,
  DELETE_PRODUCT,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAILURE,
  GET_CATEGORIES,
  DELETE_PARTICULAR_PRODUCT,
  DELETE_PARTICULAR_PRODUCT_SUCCESS,
  DELETE_PARTICULAR_PRODUCT_FAILURE
} from "../../Actions/types";

const initialState = {
  createProductLoader: false,
  createProductError: false,
  createProductData: null,
  getProductListData: null,
  getProductListLoader: false,
  getProductListError: false,
  updateProductData: null,
  updateProductLoader: false,
  updateProductError: false,
  viewProductData: null,
  viewProductLoader: false,
  viewProductError: false,
  updateStatusProductLoader: false,
  updateStatusProductData: null,
  updateStatusProductError: false,
  createAddlessondata: null,
  createAddlessonloader: false,
  createAddlessonerror: false,
  createSubAddlessondata: null,
  createsubAddlessonloader: false,
  createSubAddlessonerror: false,
  renewablesubmitdata: {},
  renewablesubmitloader: false,
  renewablesubmiterror: false,
  viewlessiontitle: null,
  viewlessiontitleloader: false,
  viewlessiontitleerror: false,
  editlession: null,
  editlessionloader: false,
  editlessionerror: false,
  viewsublessiondata: null,
  viewsublessionloader: false,
  viewsublessionerror: false,
  editsublessiondata: null,
  editsublessionloader: false,
  editsublessionerror: false,
  updatelessionstatus: null,
  updatelessionstatusloader: false,
  updatelessionstatuserror: false,
  updatesublessionstatus: null,
  updatesublessionloader: false,
  updatesublessionstatuserror: false,
  getcurriculamheading: null,
  getcurriculamheadingloader: false,
  getcurriculamheadingerror: false,
  getdeleteproductloader: false,
  getdeleteproducterror: false,
  getdeleteproduct: null,
  getcategoryloader: false,
  getcategoryerror: false,
  getcategory: null,
  getdeleteparticularproductloader:false,
  getdeleteparticularproduct:null,
  getdeleteparticularproducterror:false
};
function mainModuleManagementReducer(state = initialState, action) {
  // console.log(action, "action")
  switch (action.type) {
    case CREATE_PRODUCT:
      return { ...state, createProductLoader: true };
    case CREATE_PRODUCT_SUCCESS:
      return {
        ...state,
        createProductData: action?.payload,
        createProductLoader: false,
      };
    case CREATE_PRODUCT_FAILURE:
      return {
        ...state,
        createProductLoader: false,
        createProductError: true,
      };
    case GET_PRODUCT_LIST:
      return { ...state, getProductListLoader: true };
    case GET_PRODUCT_LIST_SUCCESS:
      return {
        ...state,
        getProductListData: action?.payload,
        getProductListLoader: false,
      };
    case GET_PRODUCT_LIST_FAILURE:
      return {
        ...state,
        getProductListLoader: false,
        getProductListError: true,
      };

    case UPDATE_PRODUCT:
      return { ...state, updateProductLoader: true };
    case UPDATE_PRODUCT_SUCCESS:
      return {
        ...state,
        updateProductData: action?.payload,
        updateProductLoader: false,
      };
    case UPDATE_PRODUCT_FAILURE:
      return {
        ...state,
        updateProductLoader: false,
        updateProductError: true,
      };

    case UPDATE_STATUS_PRODUCT:
      return { ...state, updateStatusProductLoader: true };
    case UPDATE_STATUS_PRODUCT_SUCCESS:
      return {
        ...state,
        updateStatusProductData: action?.payload,
        updateStatusProductLoader: false,
      };
    case UPDATE_STATUS_PRODUCT_FAILURE:
      return {
        ...state,
        updateStatusProductLoader: false,
        updateStatusProductError: true,
      };

    case VIEW_PRODUCT:
      return { ...state, viewProductLoader: true };
    case VIEW_PRODUCT_SUCCESS:
      return {
        ...state,
        viewProductData: action?.payload,
        viewProductLoader: false,
      };
    case VIEW_PRODUCT_FAILURE:
      return {
        ...state,
        viewProductLoader: false,
        viewProductError: true,
      };

    case RENEWABLE_LESSON_ADD_TYPE:
      return {
        ...state,
        createProductLoader: true,
      };
    case RENEWABLE_LESSON_ADD_TYPE_SUCCESS:
      return {
        ...state,
        createAddlessondata: action?.payload,
        createAddlessonloader: false,
      };

    case RENEWABLE_LESSON_ADD_TYPE_FAILURE:
      return {
        ...state,
        createProductLoader: false,
        createAddlessonerror: true,
      };

    case RENEWABLE_LESSON_ADD_SUB_TYPE:
      return {
        ...state,
        createsubAddlessonloader: true,
      };
    case RENEWABLE_LESSON_ADD_SUB_TYPE_SUCCESS:
      return {
        ...state,
        createSubAddlessondata: action?.payload,
        createsubAddlessonloader: false,
      };

    case RENEWABLE_LESSON_ADD_SUB_TYPE_FAILURE:
      return {
        ...state,
        createsubAddlessonloader: false,
        createSubAddlessonerror: true,
      };

    case RENEWABLE_LESSON_SUBMIT:
      return {
        ...state,
        renewablesubmitloader: true,
      };
    case RENEWABLE_LESSON_SUBMIT_SUCCESS:
      return {
        ...state,
        renewablesubmitdata: action?.payload,
        renewablesubmitloader: false,
      };

    case RENEWABLE_LESSON_SUBMIT_FAILURE:
      return {
        ...state,
        renewablesubmitloader: false,
        renewablesubmiterror: true,
      };

    case GET_VIEW_LESSON:
      return {
        ...state,
        viewlessiontitleloader: true,
      };
    case GET_VIEW_LESSON_SUCCESS:
      return {
        ...state,
        viewlessiontitle: action?.payload,

        viewlessiontitleloader: false,
      };
    case GET_VIEW_LESSON_FAILURE:
      return {
        ...state,
        viewlessiontitleerror: true,
        viewlessiontitleloader: false,
      };

    case EDIT_LESSON:
      return {
        ...state,
        editlessionloader: true,
      };

    case EDIT_LESSON_SUCCESS:
      return {
        ...state,
        editlession: action?.payload,
        editlessionloader: false,
      };
    case EDIT_LESSON_FAILURE:
      return {
        ...state,
        editlessionloader: false,
        editlessionerror: true,
      };

    case GET_VIEW_SUB_LESSON:
      return {
        ...state,
        viewsublessionloader: true,
      };
    case GET_VIEW_SUB_LESSON_SUCCESS:
      return {
        ...state,
        viewsublessiondata: action?.payload,

        viewsublessionloader: false,
      };
    case GET_VIEW_SUB_LESSON_FAILURE:
      return {
        ...state,
        viewsublessionerror: true,
        viewsublessionloader: false,
      };

    case EDIT_SUB_LESSON:
      return {
        ...state,
        editsublessionloader: true,
      };

    case EDIT_SUB_LESSON_SUCCESS:
      return {
        ...state,
        editsublessiondata: action?.payload,
        editsublessionloader: false,
      };
    case EDIT_SUB_LESSON_FAILURE:
      return {
        ...state,
        editsublessionloader: false,
        editsublessionerror: true,
      };

    case UPDATE_LESSION_STATUS:
      return {
        ...state,
        updatelessionstatusloader: true,
      };

    case UPDATE_LESSION_STATUS_SUCCESS:
      return {
        ...state,
        updatelessionstatusloader: false,
        updatelessionstatus: action?.payload,
      };
    case UPDATE_LESSION_STATUS_FAILURE:
      return {
        ...state,
        updatelessionstatusloader: false,
        updatelessionstatuserror: true,
      };

    case UPDATE_SUB_LESSION_STATUS:
      return {
        ...state,
        updatesublessionloader: true,
      };

    case UPDATE_SUB_LESSION_STATUS_SUCCESS:
      return {
        ...state,
        updatesublessionloader: false,
        updatesublessionstatus: action?.payload,
      };
    case UPDATE_SUB_LESSION_STATUS_FAILURE:
      return {
        ...state,
        updatesublessionloader: false,
        updatesublessionstatuserror: true,
      };

    case GET_CURRICULUM_HEADING:
      return {
        ...state,
        getcurriculamheadingloader: true,
      };
    case GET_CURRICULUM_HEADING_SUCCESS:
      return {
        ...state,
        getcurriculamheadingloader: false,
        getcurriculamheading: action?.payload,
      };

    case GET_CURRICULUM_HEADING_FAILURE:
      return {
        ...state,
        getcurriculamheadingloader: false,
        getcurriculamheadingerror:true
      };

      case DELETE_PRODUCT:
        return {
          ...state,
          getdeleteproductloader: true,
        };
      case DELETE_PRODUCT_SUCCESS:
        return {
          ...state,
          getdeleteproductloader: false,
          getdeleteproduct: action?.payload,
        };
  
      case DELETE_PRODUCT_FAILURE:
        return {
          ...state,
          getdeleteproductloader: false,
          getdeleteproducterror:true
        };

        case GET_CATEGORIES:
          return {
            ...state,
            getcatgoriesloader: false,
            getcategorieserror:true
          };

          case DELETE_PARTICULAR_PRODUCT:
        return {
          ...state,
          getdeleteparticularproductloader: true,
        };
      case DELETE_PARTICULAR_PRODUCT_SUCCESS:
        return {
          ...state,
          getdeleteparticularproductloader: false,
          getdeleteparticularproduct: action?.payload,
        };
  
      case DELETE_PARTICULAR_PRODUCT_FAILURE:
        return {
          ...state,
          getdeleteparticularproductloader: false,
          getdeleteparticularproducterror:true
        };
    default:
      return state;
  }
}

export default mainModuleManagementReducer;
